import { io } from 'socket.io-client';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

const parseTransports = () => {
  const configured = process.env.REACT_APP_SOCKET_TRANSPORTS;
  if (!configured) return ['polling'];

  const transports = configured
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);

  return transports.length ? transports : ['polling'];
};

export const realtimeBaseUrl = () => BACKEND_URL.replace(/\/api\/?$/, '');

export const createRealtimeSocket = (options = {}) => io(realtimeBaseUrl(), {
  path: '/api/socket.io',
  transports: parseTransports(),
  upgrade: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 10000,
  timeout: 20000,
  auth: { token: localStorage.getItem('token') },
  ...options,
});
